import { render, staticRenderFns } from "./customerGroupDetail.vue?vue&type=template&id=95c55d80&scoped=true"
import script from "./customerGroupDetail.vue?vue&type=script&lang=js"
export * from "./customerGroupDetail.vue?vue&type=script&lang=js"
import style0 from "./customerGroupDetail.vue?vue&type=style&index=0&id=95c55d80&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95c55d80",
  null
  
)

export default component.exports